//#region src/instrumentations/initialize.ts
function initializeInstrumentations(unpatchedConsole, internalLogger, config, metas, transports, api) {
	internalLogger.debug("Initializing instrumentations");
	const instrumentations = [];
	const add = (...newInstrumentations) => {
		internalLogger.debug("Adding instrumentations");
		newInstrumentations.forEach((newInstrumentation) => {
			internalLogger.debug(`Adding "${newInstrumentation.name}" instrumentation`);
			if (instrumentations.some((existingInstrumentation) => existingInstrumentation.name === newInstrumentation.name)) {
				internalLogger.warn(`Instrumentation ${newInstrumentation.name} is already added`);
				return;
			}
			newInstrumentation.unpatchedConsole = unpatchedConsole;
			newInstrumentation.internalLogger = internalLogger;
			newInstrumentation.config = config;
			newInstrumentation.metas = metas;
			newInstrumentation.transports = transports;
			newInstrumentation.api = api;
			instrumentations.push(newInstrumentation);
			newInstrumentation.initialize();
		});
	};
	const remove = (...instrumentationsToRemove) => {
		internalLogger.debug("Removing instrumentations");
		instrumentationsToRemove.forEach((instrumentationToRemove) => {
			var _destroy, _ref;
			internalLogger.debug(`Removing "${instrumentationToRemove.name}" instrumentation`);
			const existingInstrumentationIndex = instrumentations.reduce((acc, existingInstrumentation, existingTransportIndex) => {
				if (acc === null && existingInstrumentation.name === instrumentationToRemove.name) return existingTransportIndex;
				return null;
			}, null);
			if (existingInstrumentationIndex === null) {
				internalLogger.warn(`Instrumentation "${instrumentationToRemove.name}" is not added`);
				return;
			}
			(_destroy = (_ref = instrumentations[existingInstrumentationIndex]).destroy) === null || _destroy === void 0 || _destroy.call(_ref);
			instrumentations.splice(existingInstrumentationIndex, 1);
		});
	};
	return {
		add,
		get instrumentations() {
			return [...instrumentations];
		},
		remove
	};
}
//#endregion
export { initializeInstrumentations };

//# sourceMappingURL=initialize.js.map